// react
import PropTypes from "prop-types";
import React from "react";

// components
import Icon from "../../../../../components/Icon";

export default class File extends React.PureComponent {
	static propTypes = {
		onClick: PropTypes.func.isRequired,
		name: PropTypes.string.isRequired,
		id: PropTypes.string.isRequired,
	};

	handleClick = () => {
		this.props.onClick(this.props.id);
	};

	render() {
		const { name } = this.props;

		return (
			<div onClick={this.handleClick} className="file-container">
				<div>
					<Icon type="fa5" name={["far", "file"]} size="1x" />
					<div className="file-name">{name}</div>
				</div>
			</div>
		);
	}
}
